import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Spinner from 'components/Spinner'
import { fetchOne } from 'store/ducks/interests'
import * as selectors from 'store/ducks/interests'

class Interests extends Component {

  componentWillMount () {
    if (this.props.fetch) {
      this.props.fetchInterests()
    }
  }

  render () {
    if (this.props.isFetching) {
      return this.props.showSpinner
        ? <Spinner text='Carregando...' />
        : null
    }

    if (!this.props.data) {
      return 'Conteúdo não encontrado!'
    }

    return this.props.children({
      data: this.props.data,
      isFetching: this.props.isFetching
    })
  }

  static propTypes = {
    // From component
    children: PropTypes.func.isRequired,
    showSpinner: PropTypes.bool,
    fetch: PropTypes.bool,

    // From connect (state)
    isFetching: PropTypes.bool.isRequired,
    data: PropTypes.array,

    // From connect (dispatch)
    fetchInterests: PropTypes.func.isRequired
  }

  static defaultProps = {
    showSpinner: true,
    fetch: true
  }

}

const mapStateToProps = (state) => ({
  isFetching: selectors.isFetching(state),
  data: selectors.data(state)
})

const mapDispatchToProps = (dispatch) => ({

  fetchInterests () {
    dispatch(fetchOne())
  }

})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Interests)
